export enum Roles {
  USER = 'USER',
  MAINTAINER = 'MAINTAINER',
  ADMIN = 'ADMIN',
  SUPERADMIN = 'SUPERADMIN'
}



// WEBPACK FOOTER //
// ./src/app/models/roles.ts